import render from '@zr/i18n';
import { ImportTranslationsFn } from '@zr/i18n/d';
import { GoogleSignInButton, GoogleSignInProps } from 'zr-components/Google/SignIn/GoogleSignInButton';

import {
  LoginOrRegData,
} from '@zr/common/js/google-sign-in.d';

const translationImport: ImportTranslationsFn = () => Promise.resolve({ default: { translations: {} } });

function getInputs(): HTMLElement[] {
  const emailInput = document.getElementById('email');
  const passwordInput = document.getElementById('password');
  const submitButton = document.getElementById('submit_button');

  return [emailInput, passwordInput, submitButton].filter((element) => element !== null) as HTMLElement[];
}

const props: GoogleSignInProps = {
  onIsLoading: () => {
    getInputs().forEach((inputElement) => inputElement.setAttribute('disabled', 'disabled'));
  },
  onReady: () => {
    getInputs().forEach((inputElement) => inputElement.removeAttribute('disabled'));
  },
  onSuccessfulSignIn: (jsonResponse: LoginOrRegData) => {
    const nextUrl = jsonResponse.data?.nextUrl || '/';
    window.location.href = nextUrl;
  },
  pageType: 'sign_in_page',
  showBottomDivider: true,
};

// Show google button
const root = document.getElementById('google-button-app-root');
if (root) {
  render(GoogleSignInButton, root, translationImport, props);
}
